import { lastValueFrom, map, Observable, shareReplay } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DefaultResponse } from '../../models/http.model';
import { environment } from '../../../environments/environment';
import { BlogEntry } from '../../models/blog-models.model';


@Injectable({
  providedIn: 'root'
})
export class BlogService {

  private baseUrl: string = `assets/data/blog.json`;

  constructor(
    private http: HttpClient,
  ) { }

  getBlogEntries(): Observable<BlogEntry[]> {
    return this.http.get<BlogEntry[]>(this.baseUrl).pipe(
      shareReplay(1)
    );
  }

  getBlogEntryById(entryId: string): Observable<BlogEntry | undefined> {
    return this.getBlogEntries().pipe(
      map((entries) => entries.find((entry) => entry._id === entryId))
    );
  }

  // async getBlogEntryById(entryId: string): Promise<any> {
  //   try {
  //     const response = await lastValueFrom(this.http.get<DefaultResponse>(this.baseUrl + `get-by-id/${entryId}`));
  //     return response;
  //   } catch (error) {
  //     console.log(error);
  //     throw error;
  //   }
  // }

  // async getBlogEntries(): Promise<BlogEntry[]> {
  //   try {
  //     const response = await lastValueFrom(this.http.get<DefaultResponse>(this.baseUrl + 'get-active'))
  //     return response!.data
  //   } catch (error) {
  //     throw error;
  //   }
  // }

}
